import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

/**
 * How a job's detail came to be on screen when the user engaged with it
 * (`job_detail_engaged.source`).
 *
 * - `card`: the user tapped or clicked a card in the list;
 * - `spotlight`: the user opened the "Start here" first-match card;
 * - `auto_selected`: the desktop split view pre-selected the first job;
 * - `auto_open`: the phone opened the top match after onboarding;
 * - `deep_link`: an emailed `?job=` link;
 * - `ready`: a job chosen on the onboarding Ready step.
 */
export const JOB_ENGAGED_SOURCES = [
  "card",
  "auto_selected",
  "deep_link",
  "ready",
  "spotlight",
  "auto_open",
] as const;
export type JobEngagedSource = (typeof JOB_ENGAGED_SOURCES)[number];

/** Which layout the detail was read in (`job_detail_engaged.device`). */
export const JOB_ENGAGED_DEVICES = ["mobile", "desktop"] as const;
export type JobEngagedDevice = (typeof JOB_ENGAGED_DEVICES)[number];

/**
 * Body of `POST /jobs/:id/engaged`. Strict: an unknown key is rejected so the
 * stored `job_detail_engaged` rows stay clean to query.
 */
export const jobEngagedSchema = z
  .object({
    source: z.enum(JOB_ENGAGED_SOURCES),
    device: z.enum(JOB_ENGAGED_DEVICES),
  })
  .strict();

export class JobEngagedDto extends createZodDto(jobEngagedSchema) {}
